"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCustomer = instanceOfCustomer;
exports.CustomerFromJSON = CustomerFromJSON;
exports.CustomerFromJSONTyped = CustomerFromJSONTyped;
exports.CustomerToJSON = CustomerToJSON;
/**
 * Check if a given object implements the Customer interface.
 */
function instanceOfCustomer(value) {
    if (!('created_at' in value) || value['created_at'] === undefined)
        return false;
    if (!('customer_external_id' in value) || value['customer_external_id'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined)
        return false;
    if (!('workspace_id' in value) || value['workspace_id'] === undefined)
        return false;
    return true;
}
function CustomerFromJSON(json) {
    return CustomerFromJSONTyped(json, false);
}
function CustomerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'created_at': json['created_at'],
        'customer_external_id': json['customer_external_id'],
        'id': json['id'],
        'updated_at': json['updated_at'],
        'workspace_id': json['workspace_id'],
    };
}
function CustomerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'created_at': value['created_at'],
        'customer_external_id': value['customer_external_id'],
        'id': value['id'],
        'updated_at': value['updated_at'],
        'workspace_id': value['workspace_id'],
    };
}
